import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ConfigContext } from '../../../../contexts/ConfigContext';
import { useModuloControle } from '../../../../contexts/ModuloControleContext';
import { HEADER_BACK_COLOR, MODULOATUAL } from '../../../../store/actions';
import { Tooltip } from '@mui/material';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const NavLeft = () => {
  const storageRaw = sessionStorage.getItem('ddesp');
  const storage = JSON.parse(base64_decode(storageRaw));
  const tipoUsuario = Number(storage[7]);
  const configContext = useContext(ConfigContext);
  const { dispatch } = configContext;
  const { isDemonstracao, isPlanoResgate, ativouTesteGestao, duplicidadeCadastro } = useModuloControle();
  const history = useHistory();
  const location = useLocation();
  const [exibeAssinar, setExibeAssinar] = useState({ gestao: false, resgate: false });
  const [moduloAtual, setModuloAtual] = useState(() => (window.location.pathname.startsWith('/resgate') ? 1 : 0));
  const strgRsg = storage[39]['10'] === undefined ? true : storage[39]['10'];
 

 

  useEffect(() => {
    const proximoModulo = location.pathname.startsWith('/resgate') ? 1 : 0;
    localStorage.setItem('moduloAtual', String(proximoModulo));
    setModuloAtual(proximoModulo);
    dispatch({ type: MODULOATUAL, moduloAtual: proximoModulo });
    dispatch({
      type: HEADER_BACK_COLOR,
      headerBackColor: proximoModulo === 0 ? 'header-blue' : 'header-info',
    });
  }, [dispatch, location.pathname]);

  useEffect(() => {
    if (isDemonstracao) {
      setExibeAssinar({ gestao: true, resgate: true });
    } else if (isPlanoResgate && ativouTesteGestao) {
      setExibeAssinar({ gestao: true, resgate: false });
    } else {
      setExibeAssinar({ gestao: false, resgate: false });
    }
  }, [isDemonstracao, isPlanoResgate, ativouTesteGestao]);

  const handleModuloAtual = (modulo) => {
    localStorage.setItem('moduloAtual', String(modulo));
    setModuloAtual(modulo);
    dispatch({ type: MODULOATUAL, moduloAtual: modulo });
    dispatch({ type: HEADER_BACK_COLOR, headerBackColor: modulo === 0 ? 'header-blue' : 'header-info' });

    if (modulo === 0) {
      history.push('/dashboard');
    } else {
      history.push('/resgate/dashboard');
    }
  };

  return (
    <React.Fragment>
      {
        <ListGroup
          as='ul'
          bsPrefix=' '
          className='navbar-nav mr-auto ml-5 align-self-md-end'
        >
          <ListGroup.Item
            as='li'
            bsPrefix=' '
            className={`rounded-top nav-item pt-1 ${moduloAtual === 0 ? 'bg-base border-top border-success' : ''} pointer`}
            style={{lineHeight: '42px'}}
          >
            <Link
              to='#'
              className={`text-decoration-none mr-3  `}
            >
              {/* <i className='mdi mdi-file-chart-check-outline ' /> */}
              <span className='ml-1 f-14 text-c-blue'>Gestão </span>
              {exibeAssinar.gestao === true && (
                <Tooltip title='Planos Gestão'>
                  <Button
                    variant='success'
                    className='rounded ml-2 p-1 px-2 f-12'
                    onClick={() => {
                      history.push('/planos');
                    }}
                  >
                    Assinar
                  </Button>
                </Tooltip>
              )}
            </Link>
          </ListGroup.Item>
          
            {strgRsg && strgRsg === true && (
            <ListGroup.Item
              as='li'
              bsPrefix=' '
              className={`pointer rounded-top  nav-item ml-3 pt-1 ${moduloAtual === 1 ? 'bg-base border-top border-success text-c-blue' : ''}`}
              style={{lineHeight: '42px'}}
              onClick={() => handleModuloAtual(1)}
            >
              
                <Link
                  to='#'
                  className='text-decoration-none'
                  onClick={() => handleModuloAtual(1)}
                >
                  {/* <i className='feather icon-layout ' /> */}
                  <span className='ml-1 f-14'>Resgate XML</span>
                </Link>
             
            </ListGroup.Item>
             )}
          
        </ListGroup>
      }
    </React.Fragment>
  );
};

export default NavLeft;
